/* Shared layout for the icon container and button */
.iconLayout {
  align-items: center;
  align-self: stretch;
  display: flex;
  flex: 1;
  justify-content: center;
  position: relative;
  width: var(--spaces-16);
}

/* Centered square hit area that also serves as the focus-ring target */
.iconLayout::before {
  aspect-ratio: 1;
  bottom: auto;
  content: '';
  height: min(
    calc(100% - var(--spaces-4) * 2),
    calc(var(--spaces-16) + var(--spaces-4) * 2)
  );
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: auto;
}

.motionBounce {
  display: flex;
  align-items: center;
  align-self: stretch;
  transform-origin: var(--spaces-8);
}

.iconContainer {
  cursor: auto;
  margin-right: var(
    --vapor-text-field-input-error-margin-right,
    var(--spaces-8)
  );
}

.iconButton {
  /* button reset */
  -webkit-appearance: none;
  -webkit-tap-highlight-color: transparent;
  appearance: none;
  background: none;
  border: none;
  box-shadow: none;
  box-sizing: border-box;
  cursor: pointer;
  padding: 0;
  text-align: center;
  text-decoration: none;
  user-select: none;
  white-space: nowrap;

  margin-right: var(
    --vapor-text-field-input-error-margin-right,
    var(--spaces-8)
  );

  &:where([type='button']) {
    -webkit-appearance: none;
    appearance: none;
  }

  &:where(:focus-visible) {
    outline: none;
  }

  &:where(:focus-visible)::before {
    border-radius: var(--radii-4);
    box-shadow: 0 0 0 1.5px var(--colors-border-interactive-focused);
  }
}
